import React from 'react';
import PropTypes from 'prop-types';
import { Image as Image$1, Box } from '@zillow/constellation';
import { withPreload, prefixSpacingTokens } from '@zillow/zrs-cms';
import { withAnchor } from '../../util/helpers.js';
import StructuredData from '../../components/StructuredData/StructuredData.js';
import Paragraph from '../Paragraph/Paragraph.js';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var ImagePreload = withPreload(Image$1);
var BlockImage = function BlockImage(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var alt = attrs.alt,
    caption = attrs.caption,
    src = attrs.src,
    width = attrs.width,
    height = attrs.height,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    _attrs$decoding = attrs.decoding,
    decoding = _attrs$decoding === void 0 ? 'async' : _attrs$decoding,
    sizes = attrs.sizes,
    srcSet = attrs.srcSet,
    margin = attrs.margin;
    attrs.link;
  var structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'ImageObject',
    contentUrl: src,
    caption: alt,
    height: height,
    width: width
  };
  var isPost = usePlacement() === 'post';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StructuredData, {
    data: structuredData
  }), /*#__PURE__*/React.createElement(Box, {
    as: "figure",
    sx: Object.assign({
      // By default <figure> has these default margins
      margin: 0
    }, isPost ? {
      marginBottom: '$spacing.md'
    } : prefixSpacingTokens(margin))
  }, /*#__PURE__*/React.createElement(ImagePreload, {
    key: index,
    src: src,
    alt: alt
    // Leave width on image for SEO
    ,
    width: width,
    height: height,
    loading: loading,
    decoding: decoding,
    srcSet: srcSet,
    sizes: sizes,
    style: {
      verticalAlign: 'bottom'
    }
  }), caption && /*#__PURE__*/React.createElement(Paragraph, {
    attrs: {
      as: 'figcaption',
      fontColor: 'coolGray500',
      fontType: 'bodySmall',
      content: caption,
      textAlign: 'center',
      margin: {
        marginTop: 'xs',
        marginBottom: 'none'
      }
    }
  })));
};
BlockImage.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    loading: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Image = withAnchor(BlockImage);

export { Image as default };
